import { Component, computed, inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  Icon,
  ModalService,
  ProfileImageComponent,
  ToastService,
} from "@client";
import { Router, RouterLink, RouterModule } from "@angular/router";
import { LoginModal } from "../../modals/login/login.modal";
import { UserStore } from "../../stores/user.store";
import { CdkMenu, CdkMenuItem, CdkMenuTrigger } from "@angular/cdk/menu";
import { AlertService } from "../../services/alert.service";

@Component({
  selector: "app-login-card",
  imports: [
    CommonModule,
    Icon,
    RouterModule,
    CdkMenu,
    CdkMenuItem,
    CdkMenuTrigger,
    ProfileImageComponent,
  ],
  templateUrl: "./login-card.component.html",
  styleUrl: "./login-card.component.scss",
})
export default class LoginCardComponent {
  router = inject(Router);
  modalService = inject(ModalService);
  userStore = inject(UserStore);
  alertService = inject(AlertService);
  toastService = inject(ToastService);

  user = this.userStore.user;
  fetched = this.userStore.fetched;
  showLoginButton = computed(
    () => this.fetched() && !this.user() && !this.userStore.hasToken()
  );

  openLoginModal() {
    this.modalService.create(LoginModal);
  }

  logout() {
    this.alertService
      .open({
        icon: "completed",
        title: "로그아웃",
        message: "로그아웃을 하시겠습니까?",
        button: { label: "확인" },
      })
      .closed.subscribe((result) => {
        if (result?.role === "confirm") {
          this.userStore.logout();
          this.toastService.success("로그아웃 되었습니다.");
        }
      });
  }

  myPage() {
    if (window.innerWidth > 768) {
      this.router.navigate(["/my-page/info"], { replaceUrl: true });
    } else {
      this.router.navigate(["/my-page"], { replaceUrl: true });
    }
  }
}
